module.exports = __webpack_public_path__ + "img/streamline-icon-subtract-circle@24x24.08ec8a39.svg";